import {ReactNode} from 'react'
import {cn} from '@/lib/utils'

interface CodeTextProps {
    children: ReactNode
    className?: string
    'data-testid'?: string
}

export function CodeText({children, className, 'data-testid': testId}: CodeTextProps) {
    return (
        <code className={cn('break-all font-mono mt-1 text-sm', className)} data-testid={testId}>
            {children}
        </code>
    )
}
